<script lang="ts" generics="T, R">
	import type { Cache } from "$lib/serv/core/cache";

	export let cache: Cache<T> | undefined;
	export let type: 
	| 'filters'
	| 'restaurants'
	| 'aisle'
	| 'aisles'
	| 'occasions'
	| 'order-details';
	export let key: (payload: Cache<T>['payload'] | undefined) => R[] | undefined = (payload) => Array.isArray(payload) ? payload as R[] : [];
	export let uniqueKey: ((item: R) => string | number) | undefined = undefined;
	export let grid = true;
	export let id = '';

	interface $$Slots {
		title: {};
		default: {
			item: R;
			index: number;
			class: string;
		};
  }
</script>

	<!-- <div class="title loading headline-m book">&nbsp;</div>
	<div class="grid loading {type}">
		{#each Array(9) as _}
			<div class="item">
				<div class="image"></div>
				<div class="text"></div>
			</div>
		{/each}
	</div> -->

{#if !cache || cache.loading}
	{#if $$slots.title}
		<div class="title loading headline-m book">
			<slot name="title" />
		</div>
	{/if}
	<div class="grid loading {type}">
		{#each Array(9) as _}
			<div class="item" class:aisle={type === 'aisles'}>
				<div class="image"></div>
				<div class="text"></div>
			</div>
		{/each}
	</div>
{:else}
	{@const { error, payload } = cache}
	{@const items = key(payload)}

	{#if error}
		<div class="message error body-m book">
			<p class="body-m book">{error?.friendly_message ?? error ?? 'Unable to load grid.'}</p>
		</div>
	{:else if items}
		{#if $$slots.title}
			<slot name="title" />
		{/if}
		<div class={type} class:grid data-testid={id}>
			{#each items as item, index (uniqueKey?.(item) ?? index)}
				<slot {item} {index} class="item" />
			{/each}
		</div>
	{/if}

{/if}
